<template>
  <div class="export__wrapper">
    <b-button variant="primary" class="export__button" @click="exportUsers()">
      <b-spinner v-if="sending" small label="Spinning" />
      <span v-else>Export all Users</span>
    </b-button>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ExportAllUsersButton",
  props: {
    projectId: { type: String, default: '' }
  },
  data() {
    return {
      sending: false
    };
  },
  methods: {
    exportUsers() {
      this.sending = true;
      axios
        .get(`${this.$api_url}/projects/${this.projectId}/users-export`, this.getReqConfig({ responseType: 'blob' }))
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'Project Users.csv');
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch(error => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.sending = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.export {
  &__wrapper {
    display: flex;
    justify-content: flex-end;
  }
  &__button {
    margin-bottom: 20px;
    width: 155px;
  }
}
</style>